webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _setParallax = __webpack_require__(2);

var _setParallax2 = _interopRequireDefault(_setParallax);

var _getScrollOverElement = __webpack_require__(1);

var _getScrollOverElement2 = _interopRequireDefault(_getScrollOverElement);

var _jump = __webpack_require__(3);

var _jump2 = _interopRequireDefault(_jump);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// setParallax({
//     el: '.section-header'
// })

(0, _getScrollOverElement2.default)({
    el: '.section-festival',
    offset: 300,
    cb: function cb(el) {
        el.classList.add('is-visible');
    }
});

(0, _getScrollOverElement2.default)({
    el: '.section-veranstalter',
    offset: 300,
    cb: function cb(el) {
        el.classList.add('is-visible');
    }
});

(0, _getScrollOverElement2.default)({
    el: '.section-kontakt',
    offset: 300,
    cb: function cb(el) {
        el.classList.add('is-visible');
    }
});

function revealStart() {
    setTimeout(function () {
        document.querySelector('.section-start').classList.add('is-visible');
    }, 1000);
}

revealStart();

function jump() {

    var jumper = document.getElementById('jumper');

    jumper.addEventListener('click', function () {

        (0, _jump2.default)('.section-festival', {
            duration: 1000,
            callback: function callback() {
                document.querySelector('.section-festival').classList.add('is-visible');
            }
        });
    });
}

jump();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var el = _ref.el,
        _ref$boundry = _ref.boundry,
        boundry = _ref$boundry === undefined ? 'top' : _ref$boundry,
        _ref$offset = _ref.offset,
        offset = _ref$offset === undefined ? 0 : _ref$offset,
        cb = _ref.cb;


    var element = document.querySelector(el);

    if (element) {
        (function () {
            var getScrollOverElement = function getScrollOverElement() {

                if (window.pageYOffset >= elWithOffset) {

                    cb(element);

                    window.removeEventListener('scroll', getScrollOverElement);
                }
            };

            var scrollTop = window.pageYOffset,
                elBoundry = element.getBoundingClientRect()[boundry],
                windowHeight = window.innerHeight,
                elDistanceTop = Math.round(elBoundry - windowHeight),
                elWithOffset = elDistanceTop + offset;

            getScrollOverElement();

            window.addEventListener('scroll', getScrollOverElement);
        })();
    }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var el = _ref.el,
        _ref$attr = _ref.attr,
        attr = _ref$attr === undefined ? 'background-position-y' : _ref$attr,
        _ref$speed = _ref.speed,
        speed = _ref$speed === undefined ? 5 : _ref$speed,
        _ref$unit = _ref.unit,
        unit = _ref$unit === undefined ? 'px' : _ref$unit;


    var element = document.querySelector(el);

    if (element) {
        (function () {
            var setParallax = function setParallax() {

                var wScroll = window.pageYOffset;

                function animate() {
                    element.style[attr] = Math.ceil(wScroll / speed) + unit;
                }

                if (wScroll <= elScrollDistance) {

                    window.requestAnimationFrame(animate);
                }
            };

            // Height Calctulations
            var elHeight = element.clientHeight,
                elOffset = element.offsetTop,
                elScrollDistance = elHeight + elOffset;

            window.addEventListener('scroll', setParallax);
        })();
    }
};

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(0);


/***/ })
],[4]);


// WEBPACK FOOTER //
// main.js